import { render, staticRenderFns } from "./OnStartStorageModal.vue?vue&type=template&id=b4ba0ede&scoped=true&"
import script from "./OnStartStorageModal.vue?vue&type=script&lang=js&"
export * from "./OnStartStorageModal.vue?vue&type=script&lang=js&"
import style0 from "./OnStartStorageModal.vue?vue&type=style&index=0&id=b4ba0ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ba0ede",
  null
  
)

export default component.exports